import { JM_ENVIRONMENT } from "app/Firebase";
import {
  getApiUrlForEnvironment,
  resolveApiUrlForEnvironment,
} from "lib/apiUrlConfig";

export const getApiUrl = (path: string) =>
  getApiUrlForEnvironment(JM_ENVIRONMENT, path);

export const resolveApiUrl = (url: string) =>
  resolveApiUrlForEnvironment(JM_ENVIRONMENT, url);
